import React from 'react';
import styled from 'styled-components';

import RefundDetails from './RefundDetails';
import { Oval } from 'react-loader-spinner';
import { FlyInTransition } from '../../transitions/transitions';
import Modal from '../../../containers/common/Modal';

import close from '../../../images/refund-status-tele/close.svg';
import rupee from '../../../images/refund-status-tele/rupee.svg';
import calendar from '../../../images/refund-status-tele/calendar.svg';
import rupeeCharge from '../../../images/refund-status-tele/rupee-charge.svg';
import hashTag from '../../../images/refund-status-tele/hashtag.svg';
import pendingBank from '../../../images/refund-status-tele/pendingbank.svg';
import successBank from '../../../images/refund-status-tele/successbank.svg';
import done from '../../../images/refund-status-tele/done.svg';
import complete from '../../../images/refund-status-tele/complete.svg';
import pendingIcon from '../../../images/refund-status-tele/pending.svg';
import visitWalletIcon from '../../../images/refund-status-tele/visit.svg';
import walletIcon from '../../../images/refund-status-tele/wallet.svg';
import rupeefill from '../../../images/refund-status-tele/rupeefill.svg';
import timeClock from '../../../images/refund-status-tele/time.svg';
import ellipseIcon from '../../../images/common/ellipse.svg';

const ModalContainer = styled.div`
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
`;

const RefundContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  left: 50%;
  bottom: 0;
  transform: translate(-50%);
  width: 100vw;
  max-width: 440px;
  background: #fff;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

const RefundHead = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`;

const RefundHeadText = styled.p`
  color: #0f0b28;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const RefundHeadClose = styled.img`
  cursor: pointer;
`;

const Line = styled.div`
  border: 1px solid #ff865c;
  opacity: 0.2;
`;

const RefundDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 8px;
`;

const StatusContainer = styled.div`
  display: flex;
  padding: 0px 20px 20px 20px;
  gap: 4px;
  margin-left: auto;
`;

const StatusIcon = styled.img``;

const Status = styled.p`
  color: #7dcc18;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

const RefundStatusTele = ({ closeModal, refundData, refundLoading }) => {
  console.log('>>>>>', refundData);
  return (
    <Modal>
      <FlyInTransition
        in={true}
        mountOnEnter
        unmountOnExit
        onExited={closeModal}
        appear
      >
        <ModalContainer>
          <RefundContainer>
            <RefundHead>
              <RefundHeadText>Refund Summary</RefundHeadText>
              <RefundHeadClose src={close} alt="close" onClick={closeModal} />
            </RefundHead>
            <Line />
            {refundLoading && (
              <div className="m-auto p-8">
                <Oval
                  height="30"
                  width="100"
                  ariaLabel="oval-loading"
                  color="var(--primary-button)"
                  secondaryColor="var(--primary-button)"
                />
              </div>
            )}
            {!refundLoading && refundData && refundData.typeKey === 1 && (
              <>
                <RefundDetailsContainer>
                  <RefundDetails
                    icon={rupee}
                    details={`₹${refundData.amount}`}
                    placeHolder={'Refund Amount:'}
                  />
                  <RefundDetails
                    icon={calendar}
                    details={refundData.initiatedAt}
                    placeHolder={'Initiated on Date:'}
                  />
                  {!refundData.pending && (
                    <RefundDetails
                      icon={rupeeCharge}
                      details={refundData.processedAt}
                      placeHolder={'Processed on Date:'}
                    />
                  )}
                  {!refundData.pending && (
                    <RefundDetails
                      icon={hashTag}
                      details={refundData.refundArn}
                      placeHolder={'Reference Number:'}
                    />
                  )}
                  {!refundData.pending && (
                    <RefundDetails
                      icon={successBank}
                      details={`₹${refundData.amount}`}
                      placeHolder={'Credited to Bank Account:'}
                      bank="yes"
                      statusIcon={done}
                      pending={refundData.pending}
                    />
                  )}
                  {refundData.pending === 1 && (
                    <RefundDetails
                      icon={pendingBank}
                      details={`₹${refundData.amount}`}
                      placeHolder={`Credit to Bank Account:`}
                      bank="yes"
                      statusIcon={timeClock}
                      pending={refundData.pending}
                    />
                  )}
                </RefundDetailsContainer>
                {refundData.pending ? (
                  <StatusContainer>
                    <StatusIcon src={pendingIcon} />
                    <Status style={{ color: '#3F8CFF' }}>Processing</Status>
                  </StatusContainer>
                ) : (
                  <StatusContainer>
                    <StatusIcon src={rupeefill} />
                    <Status>Refund Completed</Status>
                  </StatusContainer>
                )}
              </>
            )}
            {!refundLoading && refundData && refundData.typeKey === 2 && (
              <>
                <RefundDetailsContainer>
                  <RefundDetails
                    icon={rupee}
                    details={`₹${refundData.amount}`}
                    placeHolder={'Refund Amount:'}
                  />
                  <RefundDetails
                    icon={calendar}
                    details={refundData.initiatedAt}
                    placeHolder={'Initiated on Date:'}
                  />
                  <RefundDetails
                    icon={rupeeCharge}
                    details={refundData.processedAt}
                    placeHolder={'Processed on Date:'}
                  />
                  <RefundDetails
                    icon={walletIcon}
                    details={`₹${refundData.amount}`}
                    placeHolder={`Credited to Wallet:`}
                    bank="yes"
                    statusIcon={done}
                    wallet="yes"
                    walletIcon={visitWalletIcon}
                  />
                </RefundDetailsContainer>
                <StatusContainer>
                  <StatusIcon src={rupeefill} />
                  <Status>Refund Completed</Status>
                </StatusContainer>
              </>
            )}

            {!refundLoading && refundData && refundData.type === 'pharmacy' && (
              <>
                <RefundDetailsContainer>
                  <RefundDetails
                    icon={rupee}
                    details={`₹${refundData?.totalAmount}`}
                    placeHolder={'Refund Amount:'}
                  />
                  <RefundDetails
                    icon={calendar}
                    details={refundData?.createdAt}
                    placeHolder={'Initiated on Date:'}
                  />
                  <RefundDetails
                    icon={rupeeCharge}
                    details={refundData?.createdAt}
                    placeHolder={'Processed on Date:'}
                  />
                  <RefundDetails
                    icon={walletIcon}
                    details={`₹${refundData?.totalAmount}`}
                    placeHolder={`Credited to Bank Account:`}
                    bank="yes"
                    statusIcon={complete}
                    wallet="no"
                    walletIcon={null}
                  />
                </RefundDetailsContainer>
                <StatusContainer>
                  <StatusIcon src={rupeefill} />
                  <Status>Refund Completed</Status>
                </StatusContainer>
              </>
            )}

            {!refundLoading && refundData && refundData.type === 'offline' && (
              <>
                <RefundDetailsContainer>
                  <RefundDetails
                    icon={rupee}
                    details={`₹${refundData.amount}`}
                    placeHolder={'Refund Amount:'}
                  />
                  {refundData.initiatedAt !== null && (
                    <RefundDetails
                      icon={calendar}
                      details={refundData.initiatedAt}
                      placeHolder={'Initiated on Date:'}
                    />
                  )}
                  {refundData.processedAt !== null && (
                    <RefundDetails
                      icon={rupeeCharge}
                      details={refundData.processedAt}
                      placeHolder={'Processed on Date:'}
                    />
                  )}
                  {refundData.refundArn && (
                    <RefundDetails
                      icon={hashTag}
                      details={refundData.refundArn}
                      placeHolder={'Reference Number:'}
                    />
                  )}
                  {refundData.walletRefund !== null &&
                    refundData.walletRefund !== 0 && (
                      <RefundDetails
                        icon={walletIcon}
                        details={`₹${refundData.walletRefund}`}
                        placeHolder={
                          refundData.walletPending === false
                            ? `Credited to Wallet:`
                            : `Credit to Wallet`
                        }
                        bank="yes"
                        statusIcon={
                          refundData.walletPending === false
                            ? complete
                            : timeClock
                        }
                        wallet={
                          refundData.walletPending === false ? 'yes' : 'no'
                        }
                        walletIcon={visitWalletIcon}
                      />
                    )}

                  {refundData.creditedToBank !== null &&
                    refundData.creditedToBank !== 0 && (
                      <RefundDetails
                        icon={successBank}
                        details={`₹${refundData.creditedToBank}`}
                        placeHolder={
                          refundData.pending === false
                            ? 'Credited to Bank Account:'
                            : `Credit to Bank Account:`
                        }
                        infoMsg={refundData.infoMsg}
                        bank="yes"
                        statusIcon={
                          refundData.pending === false ? complete : timeClock
                        }
                        pending={refundData.pending}
                      />
                    )}
                </RefundDetailsContainer>

                {refundData.pending === null &&
                refundData.walletPending === null ? (
                  <></>
                ) : (refundData.pending === false &&
                    refundData.walletPending === false) ||
                  (refundData.pending == false &&
                    refundData.walletPending == null) ||
                  (refundData.pending == null &&
                    refundData.walletPending == false) ? (
                  <StatusContainer>
                    <StatusIcon src={rupeefill} />
                    <Status>Refund Completed</Status>
                  </StatusContainer>
                ) : (
                  <StatusContainer>
                    <StatusIcon src={ellipseIcon} className="icon-spin" />
                    <Status style={{ color: '#3F8CFF' }}>Processing</Status>
                  </StatusContainer>
                )}
              </>
            )}

            {!refundLoading && refundData && refundData.type === 'Labs' && (
              <>
                <RefundDetailsContainer>
                  <RefundDetails
                    icon={rupee}
                    details={`₹${refundData.amount}`}
                    placeHolder={'Refund Amount:'}
                  />
                  {refundData.initiatedAt !== null && (
                    <RefundDetails
                      icon={calendar}
                      details={refundData?.initiatedAt}
                      placeHolder={'Initiated on Date:'}
                    />
                  )}
                  {refundData.hasOwnProperty('accountProcessedOn') &&
                    refundData.accountProcessedOn !== null && (
                      <RefundDetails
                        icon={rupeeCharge}
                        details={refundData?.accountProcessedOn}
                        placeHolder={'Processed on Date:'}
                      />
                    )}
                  {refundData.hasOwnProperty('walletProcesedOn') &&
                    refundData.walletProcesedOn && (
                      <RefundDetails
                        icon={rupeeCharge}
                        details={refundData?.walletProcesedOn}
                        placeHolder={'Processed on Date:'}
                      />
                    )}

                  {refundData.refundArn && (
                    <RefundDetails
                      icon={hashTag}
                      details={refundData.refundArn}
                      placeHolder={'Reference Number:'}
                    />
                  )}
                  {refundData.hasOwnProperty('creditedToBank') &&
                    refundData.creditedToBank !== null &&
                    refundData.creditedToBank !== 0 && (
                      <RefundDetails
                        icon={successBank}
                        details={`₹${refundData.creditedToBank}`}
                        placeHolder={
                          refundData.pending === false
                            ? 'Credited to Bank Account:'
                            : `Credit to Bank Account:`
                        }
                        infoMsg={refundData.infoMsg}
                        bank="yes"
                        statusIcon={
                          refundData.pending === false ? complete : timeClock
                        }
                        pending={refundData.pending}
                      />
                    )}
                  {refundData.hasOwnProperty('walletRefund') &&
                    refundData.walletRefund &&
                    refundData.walletRefund > 0 && (
                      <RefundDetails
                        icon={successBank}
                        details={`₹${refundData.walletRefund}`}
                        placeHolder={
                          refundData.walletPending === false
                            ? 'Credited to wallet:'
                            : `Credit to wallet:`
                        }
                        infoMsg={refundData.infoMsg}
                        bank="yes"
                        statusIcon={
                          refundData.walletPending === false
                            ? complete
                            : timeClock
                        }
                        pending={refundData.walletPending}
                        wallet="yes"
                        walletIcon={visitWalletIcon}
                      />
                    )}
                </RefundDetailsContainer>

                {refundData?.pending === null ? (
                  <></>
                ) : !refundData?.pending ? (
                  <StatusContainer>
                    <StatusIcon src={rupeefill} />
                    <Status>Refund Completed</Status>
                  </StatusContainer>
                ) : (
                  <StatusContainer>
                    <StatusIcon src={ellipseIcon} className="icon-spin" />
                    <Status style={{ color: '#3F8CFF' }}>Processing</Status>
                  </StatusContainer>
                )}
              </>
            )}
          </RefundContainer>
        </ModalContainer>
      </FlyInTransition>
    </Modal>
  );
};

export default RefundStatusTele;
